import { useLayoutStore } from '@/store/modules/layout';
export default {
  name: 'SidenavCollapse',
  props: {
    collapseRef: {
      type: String,
      required: true
    },
    navText: {
      type: String,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const layoutStore = useLayoutStore();
    return {
      isExpanded: false,
      isRTL: layoutStore.isRTL
    };
  }
};